var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8576 32.8377L39.8104 16.7905C38.2677 15.2477 35.7659 15.2477 34.2234 16.7905L1.15724 49.8564C-0.385504 51.3992 -0.385504 53.9007 1.15724 55.4434L17.2045 71.4906C18.747 73.0331 21.2495 73.0326 22.7915 71.4906L55.8579 38.4244C57.4006 36.8817 57.4006 34.3804 55.8576 32.8377Z",
    fill: "#C49545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.843 49.8562L93.7766 16.79C92.2338 15.2472 89.7321 15.2472 88.1896 16.79L72.1424 32.8372C70.5996 34.38 70.5996 36.8815 72.1424 38.4242L105.209 71.4906C106.751 73.0331 109.254 73.0326 110.796 71.4904L126.843 55.4432C128.386 53.9004 128.386 51.3987 126.843 49.8562Z",
    fill: "#C49545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2636 70.2426C89.9206 66.8993 74.2739 51.2521 68.6309 45.6109C67.0224 44.0031 64.9841 42.8979 62.7791 42.4159C61.6599 44.0169 27.9204 77.5373 27.3617 77.9823C27.8577 80.1413 28.9522 82.1353 30.5317 83.7148L54.3254 107.506C62.8769 116.064 71.3791 111.878 74.3639 106.001L59.2514 90.8883C57.7086 89.3456 57.7086 86.8441 59.2514 85.3013C60.7939 83.7586 63.2956 83.7586 64.8384 85.3013L79.9043 100.367C83.0901 98.8185 85.5751 95.788 86.2593 92.0063L72.1964 77.9433C70.6536 76.4006 70.6536 73.8991 72.1964 72.3563C73.7389 70.8136 76.2406 70.8136 77.7833 72.3563L93.2771 87.8503C98.2003 83.5671 99.0158 75.9961 93.2636 70.2426Z",
    fill: "#C49545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHand);
export default __webpack_public_path__ + "static/media/iconHand.574c5db05d1f016bbdd30e970e6eb251.svg";
export { ForwardRef as ReactComponent };